export { default } from "ember-simple-auth/initializers/ember-simple-auth";
